export default "__VITE_ASSET__107cb1b0__"